<template>
  <div class="form-group row">
    <alert-comp :msg="msgAlert" />
    <div class="col-11 row">
      <div class="col-sm-12" v-if="errosValidacaoReserva.length">
        <font size="1">
          <p size="1" class="erro">
            <b size="1">Favor, verificar o(s) campo(s) abaixo:</b>
            <ul size="1">
              <li v-for="erro in errosValidacaoReserva" v-bind:key="erro" size="1">
                {{ erro }}
              </li>
            </ul>
          </p>
        </font>
      </div>
      <div class="col-sm-2 text-sm-right">
        <label>Quantidade:</label>
      </div>
      <div class="col-md-4 col-sm-10 mb-3">
        <input type="number" min="1" class="form-control" v-model="reserva.quantidadeNumeroReservado">
        <label class="erro">{{erroValicaoReservaQuantidadeMinima}}</label>
        <label class="erro">{{erroValicaoReservaQuantidadeMaxima}}</label>
      </div>
      <div class="col-sm-2 text-sm-right">
        <label>Tipo Protocolo</label>
      </div>
      <div class="col-md-4 col-sm-10 mb-3">
        <div class="form-check form-check-inline">
          <label class="mr-1" v-for="(item) in tiposProtocolo" :key="item.key">
            <input type="radio"
              class="form-check-input"
              :value="item.key"
              :checked="reserva.tipoProtocolo == item.key"
              v-model="reserva.tipoProtocolo">
            {{ item.value }}
          </label>
        </div>
      </div>

      <div class="col-sm-2 text-sm-right">
        <label>Motivo da Reserva:</label>
      </div>
      <div class="col-sm-10 mb-3">
        <textarea class="form-control" v-model="reserva.motivoReserva" rows="5"></textarea>
        <label class="erro">{{erroValicaoReservaMotivo}}</label>
      </div>

      <div class="col-12 row btnAcoes">
        <div class="col-1"></div>
        <button class="btn btn-outline-success" @click.prevent="reservar"> Reservar </button>
        <button class="btn btn-outline-danger" @click.prevent="cancelar"> Cancelar </button>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '@/uteis/eventBus'
import alertComp from '@/components/alert/AlertComp'

import ReservaProtocoloService from '@/services/ReservaProtocoloService'

export default {
  name: 'reservarProtocolo',

  components: {
    alertComp
  },

  props: {
    eventBusDataName: { required: true, type: String },
    eventBusPaginationName: { required: true, type: String },
    eventBusShowComponent: { required: true, type: String }
  },

  data () {
    return {
      msgAlert: {
        texto: '',
        type: ''
      },
      reserva: {
        quantidadeNumeroReservado: 1,
        motivoReserva: '',
        tipoProtocolo: 'PROCESSO',
        situacao: 'ATIVO'
      },
      filtro: {
        idReservaProtocolo: '',
        motivoReserva: '',
        tipoProtocolo: 'PROCESSO',
        offset: 1,
        range: this.rowsNumber ? this.rowsNumber : 10
      },
      tiposProtocolo: [{
        value: 'Documento Avulso',
        key: 'DOCUMENTO_AVULSO'
      }, {
        value: 'Processo',
        key: 'PROCESSO'
      }],
      errosValidacaoReserva: [],
      erroValicaoReservaQuantidadeMinima: '',
      erroValicaoReservaQuantidadeMaxima: '',
      erroValicaoReservaMotivo: ''
    }
  },

  created () {
    this.dadosSessao = this.$store.getters.getDadosSessao
    this.filtro.usuario = this.dadosSessao.sessao.login
    this.filtro.idDepartamento = this.dadosSessao.sessao.idDepartamento
    this.reserva.sessaoUsuario = this.dadosSessao.sessao
    this.service = new ReservaProtocoloService()
  },

  methods: {
    reservar () {
      if (this.valicacaoReservaProtocolo()) {
        this.service.reservarProtocolo(this.reserva).then((response) => {
          this.filtro.tipoProtocolo = this.reserva.tipoProtocolo
          this.pesquisar()
          this.limpar()
        }).catch(err => {
          console.log(err)
        })
      }
    },

    limpar () {
      this.reserva.quantidade = ''
      this.reserva.motivoReserva = ''
      this.msgAlert.texto = ''
      this.msgAlert.type = ''
      this.reserva.quantidadeNumeroReservado = 1
      this.errosValidacaoReserva = []
      this.erroValicaoReservaQuantidadeMinima = ''
      this.erroValicaoReservaQuantidadeMaxima = ''
      this.erroValicaoReservaMotivo = ''
    },

    cancelar () {
      this.limpar()

      eventBus.$emit(this.eventBusShowComponent, false)
    },

    trocaDePagina (numeroPagina) {
      this.reserva.offset = numeroPagina
      this.pesquisar()
    },

    pesquisar () {
      this.service.buscarReservasProtocolo(this.filtro).then((response) => {
        eventBus.$emit(this.eventBusDataName, response)
      }).catch(err => {
        console.log(err)
      })
    },

    valicacaoReservaProtocolo () {
      let quantidadeProtocoloReservar = 0
      this.errosValidacaoReserva = []
      this.erroValicaoReservaQuantidadeMinima = ''
      this.erroValicaoReservaQuantidadeMaxima = ''
      this.erroValicaoReservaMotivo = ''
      quantidadeProtocoloReservar = this.reserva.quantidadeNumeroReservado

      if (this.reserva.quantidadeNumeroReservado === '0' || !this.reserva.quantidadeNumeroReservado) {
        this.erroValicaoReservaQuantidadeMinima = '*Quantidade a ser reservada deve ser maior que 0.'
        this.errosValidacaoReserva.push('Favor verificar campo quantidade a ser armazenada.')
      } else if (quantidadeProtocoloReservar > 100) {
        this.erroValicaoReservaQuantidadeMaxima = '*Quantidade a ser reservada deve ser menor ou equivalente a 100 unidades.'
        this.errosValidacaoReserva.push('Favor verificar campo quantidade a ser armazenada, quantidade maxima de reserva é de 100 unidades por reserva')
      }

      if (!this.reserva.motivoReserva) {
        this.erroValicaoReservaMotivo = '*Motivo de reserva obrigatório.'
        this.errosValidacaoReserva.push('Favor verificar campo motivo da reserva.')
      }

      if (!this.errosValidacaoReserva.length) {
        return true
      }
    }
  }
}
</script>

<style scoped lang="scss">
.row {
  margin-top: 2px;
}
.erro {
  color: orange;
}
</style>
